import React from "react";
import { useSelector } from "react-redux";
import { getFeedbackForm } from "../../../../redux/reducer/incbotFeedbackReducer";
import readingIcon from "../../../../assets/images/cefr/reading-icon.svg";
import listeningIcon from "../../../../assets/images/cefr/listening-icon.svg";
import writingIcon from "../../../../assets/images/cefr/writing-icon.svg";
import speakingIcon from "../../../../assets/images/cefr/speaking-icon.svg";

const FinalRemarksView: React.FC = () => {
  const feedbackForm = useSelector(getFeedbackForm);

  const parseRemarks = (data: string) => {
    if (!data) return {};
    const sections: Record<string, string[]> = {};
    let currentSection = "";

    data.split("\n").forEach((line) => {
      const trimmedLine = line.trim();
      if (!trimmedLine) return;

      if (trimmedLine.endsWith(":")) {
        currentSection = trimmedLine.slice(0, -1);
        sections[currentSection] = [];
      } else if (trimmedLine.startsWith("-") && currentSection) {
        sections[currentSection].push(trimmedLine.substring(1).trim());
      }
    });

    return sections;
  };

  const remarksData = parseRemarks(feedbackForm?.finalRemarks?.data || "");

  const strengthsWeaknesses = [
    {
      category: "Listening",
      icon: <img src={listeningIcon} alt="Listening" className="w-8 h-8 md:w-8 md:h-8" />,
      color: "text-red-600",
      items: remarksData["Listening"] || [],
    },
    {
      category: "Reading",
      icon: <img src={readingIcon} alt="Reading" className="w-8 h-8 md:w-8 md:h-8" />,
      color: "text-blue-600",
      items: remarksData["Reading"] || [],
    },
  ];

  const assessmentSections = [
    {
      title: "Writing",
      icon: <img src={writingIcon} alt="Writing" className="w-8 h-8 md:w-8 md:h-8" />,
      color: "text-purple-600",
      items: remarksData["Writing"] || [],
    },
    {
      title: "Speaking",
      icon: <img src={speakingIcon} alt="Speaking" className="w-8 h-8 md:w-8 md:h-8" />,
      color: "text-green-600",
      items: remarksData["Speaking"] || [],
    },
  ];

  const allCefrSections = [...strengthsWeaknesses, ...assessmentSections];
  const filteredSections = allCefrSections.filter((section) => (section.items?.length ?? 0) > 0);

  return (
    <div className="p-3 md:p-6">
      <div className="md:hidden print:flex w-100 p-1 print:p-2 rounded-md border-b-4 border-teal-500 bg-teal-50 text-teal-500 text-md print:text-xl flex justify-center font-semibold mb-3 md:mb-6">
        Final Remarks
      </div>

      {feedbackForm?.AIGenTextBanner && (
        <div className="bg-yellow-50 border border-yellow-200 text-yellow-800 p-4 md:p-6 rounded-md mb-3">
          <p className="text-sm md:text-md font-semibold text-red-500 mb-1">
            AI-Assisted Response Detected
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            Our system has identified that the candidate may have relied on AI-generated responses
            during the assessment.
          </p>
        </div>
      )}

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-6">
        {filteredSections.map((section: any, index: number) => (
          <div key={index} className="bg-white rounded-lg border border-gray-200">
            <div className="flex items-center space-x-2 px-4 pt-4 py-3">
              <div className={section.color}>{section.icon}</div>
              <h2 className="text-md md:text-lg font-semibold text-gray-900">
                {section.category || section.title}
              </h2>
            </div>
            <hr />
            <div className="space-y-2 md:space-y-4 p-2 md:px-5 pb-4 pt-4">
              {section.items.map((item: string, itemIndex: number) => (
                <div key={itemIndex} className="flex items-start space-x-2">
                  <div className="w-1 h-1 md:w-2 md:h-2 bg-[#133F7D] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-xs md:text-sm text-gray-700">{item}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FinalRemarksView;
